<template>
  <div id="user-registration">
    <Form
      v-if="form_step === 'first'"
      :header="header"
      :model="model"
      :schema="schema"
      :buttons="first_step_buttons"
      @form_submit="form_submit"
      @button_click="button_click"></Form>
    <CardContainer v-else>
      <Header :icon="header.icon">{{ header.title }}</Header>

      <b-alert
        v-for="message in messages"
        :key="message.name"
        show
        :variant="message.variant">
        {{ message.label }}
      </b-alert>

      <hr class="col-xs-12" />

      <div class="text-gray">
        <p>Zakładając konto, otrzymujesz produkt:</p>

        <p class="h4 font-weight-bold my-4">Wniosek o upadłość konsumencką</p>

        <p class="mb-4">
          Aby dokończyć rejestrację, należy wnieść opłatę przy pomocy jednej z
          wybranych metod płatności dostępnych po kliknięciu w przycisk
          <strong>Przejdź do płatności.</strong>
        </p>

        <p class="d-inline h5 mr-2">Cena:</p>
        <p class="d-inline h5 text-danger">249 zł</p>
      </div>

      <hr class="col-xs-12 mt-4" />

      <FormButtons
        :buttons="second_step_buttons"
        @button_click="button_click"></FormButtons>
    </CardContainer>
  </div>
</template>

<script>
import Vue from "vue";
import Form from "../../components/Form";
import FormButtons from "../../components/FormButtons";
import Header from "../../components/Header";
import CardContainer from "../../components/CardContainer";
import VueFormGenerator from "vue-form-generator";
import { get_validator_messages } from "../../validators/locale_pl";

const validator_messages = get_validator_messages();

export default {
  name: "UserRegistration",
  components: {
    Form,
    FormButtons,
    Header,
    CardContainer
  },
  data() {
    return {
      form_step: "first",
      header: {
        title: "Rejestracja",
        icon: "person-plus-fill"
      },
      first_step_buttons: [
        {
          name: "buttons_wrapper",
          style_classes: "float-right btn-group",
          buttons: [
            {
              label: "Mam już konto",
              name: "redirect-to-login",
              variant: "primary",
              type: "button",
              icon: "shield-lock-fill"
            },
            {
              label: "Dalej",
              name: "next-step",
              variant: "success",
              type: "submit",
              icon: "chevron-right",
              icon_right: true
            }
          ]
        }
      ],
      second_step_buttons: [
        {
          name: "buttons_wrapper",
          style_classes: "float-right btn-group",
          buttons: [
            {
              id: "previous-step-btn",
              label: "Powrót",
              name: "previous-step",
              variant: "primary",
              type: "button",
              icon: "chevron-left"
            },
            {
              id: "register-btn",
              label: "Przejdź do płatności",
              name: "register",
              variant: "success",
              type: "button",
              icon: "person-plus-fill",
              spinner: true,
              spinner_id: "loading-spinner"
            }
          ]
        }
      ],
      model: {
        email: null,
        given_name: null,
        family_name: null,
        phone_number: null,
        checkbox_first: false,
        checkbox_second: false
      },
      messages: [],
      schema: {
        groups: [
          {
            styleClasses: "form-row",
            fields: [
              {
                styleClasses: "col-lg-12",
                type: "input",
                inputType: "email",
                label: "Email",
                model: "email",
                required: true,
                validator: [
                  VueFormGenerator.validators.email.locale(validator_messages)
                ]
              },
              {
                styleClasses: "col-lg-6",
                type: "input",
                inputType: "text",
                label: "Imię",
                model: "given_name",
                required: true,
                autocomplete: true,
                validator: [
                  VueFormGenerator.validators.required.locale(
                    validator_messages
                  )
                ]
              },
              {
                styleClasses: "col-lg-6",
                type: "input",
                inputType: "text",
                label: "Nazwisko",
                model: "family_name",
                required: true,
                autocomplete: true,
                validator: [
                  VueFormGenerator.validators.required.locale(
                    validator_messages
                  )
                ]
              },
              {
                styleClasses: "col-lg-12",
                type: "input",
                inputType: "text",
                label: "Telefon",
                model: "phone_number",
                required: true,
                validator: [VueFormGenerator.validators.phoneNumberValidator]
              },
              {
                styleClasses: "col-lg-12 user-registration__checkbox",
                type: "checkbox",
                label: `Akceptuję <a href="${Vue.Backend.bucket_url}/Regulamin.pdf" target="_blank">regulamin</a>`,
                model: "checkbox_first",
                required: true,
                validator: [
                  VueFormGenerator.validators.checkboxRequiredValidator
                ]
              },
              {
                styleClasses: "col-lg-12 user-registration__checkbox",
                type: "checkbox",
                label: `Akceptuję <a href="${Vue.Backend.bucket_url}/Polityka-prywatności.pdf" target="_blank">politykę prywatności</a>`,
                model: "checkbox_second",
                required: true,
                validator: [
                  VueFormGenerator.validators.checkboxRequiredValidator
                ]
              }
            ]
          }
        ]
      }
    };
  },
  methods: {
    form_submit: function () {
      this.form_step = "second";
    },
    handle_registration: function () {
      this.disable_buttons(true);
      this.display_loading_spinner(true);

      Vue.CognitoAuth.sign_up(
        {
          username: this.model.email,
          family_name: this.model.family_name,
          given_name: this.model.given_name,
          phone_number: "+48" + this.model.phone_number
        },
        this.handle_register_success,
        this.handle_register_failure
      );
    },
    handle_register_success: function (response) {
      const transaction_token = response.data.token;

      Vue.PaymentGateway.redirect_to_payment_panel(transaction_token);
    },
    handle_register_failure: function (error) {
      this.disable_buttons(false);
      this.display_loading_spinner(false);

      this.messages = [
        {
          label: error,
          variant: "danger"
        }
      ];
    },
    disable_buttons: function (should_disable) {
      const register_btn = document.getElementById("register-btn");
      const previous_step_btn = document.getElementById("previous-step-btn");

      register_btn.disabled = should_disable;
      previous_step_btn.disabled = should_disable;
    },
    display_loading_spinner: function (should_display) {
      const spinner = document.getElementById("loading-spinner");
      if (should_display) {
        spinner.style.display = "block";
      } else {
        spinner.style.display = "None";
      }
    },
    button_click: function (button_name) {
      switch (button_name) {
        case "redirect-to-login":
          this.$router.push({ name: "Login" });
          break;
        case "previous-step":
          this.form_step = "first";
          break;
        case "register":
          this.handle_registration();
      }
    }
  }
};
</script>

<style>
.user-registration__checkbox {
  user-select: none;
}

.user-registration__checkbox .field-wrap input {
  margin-top: 0 !important;
}

.user-registration__checkbox label {
  margin-bottom: 0;
}

.user-registration__checkbox label > :first-child {
  font-size: medium;
  padding-top: 5px;
}

@media (min-width: 768px) {
  #user-registration .form-container {
    max-width: 520px;
  }
}
</style>
